module.exports = __webpack_public_path__ + "static/img/post_01-300x184.b2db0cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post_01-300x184.jpg
// module id = FO4n
// module chunks = 0